import React, { useState } from 'react';

const MenuLinks = (props) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [isDropList, setIsDropList] = useState(false);

    return (
        <div className="mainBlock__top-menu-links w-full flex justify-between space-x-4">
            {props.data.navDesc.map((item, index) => (
                <a
                    key={item.id}
                    href={item.link}
                    style={{
                        color: hoveredIndex === index ? props.data.colors[0].colorRed : props.color 
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    {item.text}
                </a>
            ))}
            <div 
                className="relative"
                onMouseEnter={() => setIsDropList(true)}
                onMouseLeave={() => setIsDropList(false)}
            >
                <button style={{
                    color: isDropList ? props.data.colors[0].colorRed : props.color
                }}>
                    Доп информация
                </button>
                {isDropList && (
                    <div className='absolute z-10 pt-[5px]'>
                        <div className=" bg-white shadow-md rounded-[10px] w-[150px]">
                            {props.data.navDescDopInfo.map((item) => (
                                <a
                                    key={item.id}
                                    className="block p-3 cursor-pointer rounded-[10px] hover:bg-gray-200"
                                    href={item.link}
                                >
                                    {item.text}
                                </a>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MenuLinks;
